<template>
    <div class="row">
        <div class="form-group col-12">
            <label>Active MILUIM?</label>
            <b-form-checkbox
                v-model="questionnaire.activeMiluim"
                switch
                :class="{
                    'is-invalid': hasError('activeMiluim')
                }"
            />

            <div class="invalid-feedback">
                {{ getError('activeMiluim') }}
            </div>
        </div>

        <div class="form-group col-12">
            <label>Living in dorms?</label>
            <b-form-checkbox
                v-model="questionnaire.livingInDorms"
                switch
                :class="{
                    'is-invalid': hasError('livingInDorms')
                }"
            />

            <div class="invalid-feedback">
                {{ getError('livingInDorms') }}
            </div>
        </div>

        <div class="form-group col-12">
            <label>Neighborhood?</label>
            <v-select v-model="questionnaire.neighborhood" :options="options" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            defaultQuestionnaire: {
                activeMiluim: false,
                livingInDorms: false,
                neighborhood: null
            },
            questionnaire: {},
            options: ['a', 'b', 'c', 'd']
        };
    },

    watch: {
        questionnaire() {
            this.$emit('input', this.questionnaire);
        }
    },

    created() {
        this.questionnaire = {
            ...this.defaultQuestionnaire,
            ...this.value
        };
    },

    methods: {
        hasError(key) {
            return (
                this.validation.questionnaire[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.questionnaire,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
